import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { PageHeaderModule } from 'Src/ng2/shared/components/header/page-header/page-header.module';
import { SideNavNgModule } from '../../shell/side-nav/side-nav.module';
import { OtherToolsModule } from './other-tools/other-tools.module';

@NgModule({
  imports: [OtherToolsModule, RouterModule, MatListModule, SideNavNgModule, PageHeaderModule],
  exports: [],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SchoolToolsModule {
  //
}
